import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        space: {
            type: Object,
            required: true
        }
    }
});
